(function () {
    'use strict';

    angular.module('swif.framework')
        .factory('AttachmentService', AttachmentService);


    /**
     * @ngdoc service
     * @name swif.framework.AttachmentService
     * @requires swif.framework.dataService
     * @requires swif.framework.msgService
     **/
    function AttachmentService($q, dataService, openstcRightsService, userService, settingsService, msgService) {
        'ngInject';
        var service = {};

        service.IMG_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif'];

        service.attachmentPreModal = function (data, collection) {
            service.addAttachments(data.model);
            data.model._uploadCallback = function (values) {
                data.model.attachment_count = values.count;
                if(collection) {
                    collection.updateItem(data.model);
                }
                data.model._attachments_img = service.getImages(values.attachments);
            };

            if (settingsService.app.modules.openstc && userService.getAccessRights().openstc_full_view) {
                data.model._fullView = true;
            }
            data.model._user_id = userService.getAuthenticatedUser().uid;
        };

        service.addAttachments = function (model) {
            model._attachments = [];
            model._attachments_img = [];
            // if user can't read an intervention, he can only see ask's attachments
            if (openstcRightsService.getUserAbility().is.claimer){
                setAttachments(model, model);
            }else {
                //sinon l'utilisateur est gestionnaire/technicien
                //TODO : if this code is going to be re-use (like the code to get the all folder)
                if (model._type === 'intervention_request'){
                    setAttachments(model, model);
                    var filter = {};
                    dataService.addFilter(filter, 'ask_id', '=', model.id);
                    dataService.searchRead('intervention', filter).then(function (intervention) {
                        if (intervention.length>0){
                            setAttachments(model, intervention.records[0]);

                            var tfilter = {};
                            dataService.addFilter(tfilter, 'project_id', '=', intervention.ids[0]);
                            dataService.searchRead('task', tfilter)
                                .then(function (data) {
                                    data.records.forEach(function(task){
                                        setAttachments(model, task);
                                    });
                                });
                        }
                    });
                }
                if (model._type === 'intervention') {
                    setAttachments(model, model);

                    var tfilter = {};
                    dataService.addFilter(tfilter, 'project_id', '=', model.id);
                    dataService.searchRead('task', tfilter)
                        .then(function (data) {
                            data.records.forEach(function(task){
                                setAttachments(model, task);
                            });
                        });

                    var filter = {};
                    if(model.ask_id){
                        dataService.addFilter(filter, 'id', '=', model.ask_id[0]);
                        dataService.searchRead('intervention_request', filter).then(function (demande) {
                            if (demande.length > 0) {
                                setAttachments(model, demande.records[0]);
                            }
                        });
                    }
                }
                if (model._type === 'task'){
                    var filter = {};
                    dataService.addFilter(filter, 'id', '=', model.project_id[0]);
                    dataService.searchRead('intervention', filter).then(function (intervention) {
                        if (intervention.length>0){
                            setAttachments(model, intervention.records[0]);

                            var tfilter = {};
                            dataService.addFilter(tfilter, 'project_id', '=', intervention.records[0].id);
                            dataService.searchRead('task', tfilter)
                                .then(function (data) {
                                    data.records.forEach(function(task){
                                        setAttachments(model, task);
                                    });

                                    var tfilter = {};
                                    dataService.addFilter(tfilter, 'id', '=', intervention.records[0].ask_id[0]);
                                    dataService.searchRead('intervention_request', tfilter)
                                        .then(function (demande) {
                                            if (demande.length>0) {
                                                setAttachments(model, demande.records[0]);
                                            }
                                        });
                                });
                        } else {
                            setAttachments(model, model);
                        }
                    });
                }
                if (model._type === 'openstc_ask_prod'){
                    var filter = {};
                    dataService.addFilter(filter, 'id', '=', model.id);
                    dataService.searchRead('openstc_ask_prod', filter).then(function (ask) {
                        if (ask.length>0){
                            setAttachments(model, ask.records[0]);
                        }
                    });
                }
                if (model._type != 'intervention_request' && model._type != 'intervention' && model._type != 'task' && model._type != 'openstc_ask_prod'){
                    setAttachments(model, model);
                }

            }
        };

        function setAttachments(model, res) {
            service.getAttachments(res).then(function (ret) {
                addOrigin(ret.attachments, res._type);
                addFolderData(ret.attachments, res);
                addSwifId(ret.attachments, res.swif_id);
                service.concatAttachments(model, ret.attachments);
            });
        };

        service.getAttachments = function (model) {
            var res_model = dataService._getModel(model._type);
            var filter = {fields: ['actions', 'id', 'datas_fname', 'create_uid', 'create_date', 'name']};
            dataService.addFilter(filter, 'res_model', '=', res_model);
            dataService.addFilter(filter, 'res_id', '=', model.id);
            return dataService.get('attachment', undefined, filter).then(function (values) {
                return dataService.get(model._type, model.id, {fields: ['attachment_count']})
                    .then(function (newModel) {
                        return {
                            attachments: values,
                            count: newModel.attachment_count
                        };
                    });
            });
        };

        service.concatAttachments = function (model, attachments) {
            model._attachments = model._attachments.concat(attachments);
            model._attachments_img = model._attachments_img = model._attachments_img.concat(service.getImages(attachments));
        };

        //size files can't be over 20MB
        service.checkFileSize = function (files){
            var fileToCheck = files[0];
            if(fileToCheck.size > 20000000){
                var message = ("Votre pièce jointe est trop lourde, elle ne peut excéder 20MB.")
                return msgService.addError({
                    code: 200,
                    type: 'danger',
                    data: {
                        fault_code: message
                    }
                });
            }
            return true;
        }

        service.uploadFiles = function (files, model) {
            if(files){
                var res_model = dataService._getModel(model._type);
                var fileToAdd = files[0];
                //if we are on chrome, parse the fakepath to retrieve the filename
                // We need a file name for the attachment modal, so 'file' is set by default
                var filename = 'file';
                if (fileToAdd.name != undefined) {
                    filename = fileToAdd.name.split('/');
                    filename = filename[filename.length - 1];
                }
                //prepare params to initialize the model
                var params = {
                    datas: null,
                    datas_fname: filename,
                    name: filename,
                    res_model: res_model,
                    res_id: model.id
                };

                //initialize the FileReader in order to retrieve binary data of the attachment to upload
                //the onload() method will perform the model instanciation and the addLine()
                var reader = new FileReader();
                var ret = $q.defer();
                reader.onload = function(file){
                    params.datas = btoa(file.target.result);
                    dataService.create('attachment', params).then(function (data) {
                        dataService.get(model._type, model.id, {fields: ['attachment_count']});
                        ret.resolve(data);
                    });
                };
                reader.readAsBinaryString(fileToAdd);
                // finally, perform the upload on the server
                return ret.promise;
            }
        };

        service.isImage = function (attachment) {
            var isImage = false;
            _.forEach(service.IMG_EXTENSIONS, function (ext) {
                if (endsWith(attachment.datas_fname, ext)) {
                    isImage = true;
                }
            });
            return isImage;
        };

        service.getImages = function (model) {
            var images = [];
            if (_.isArray(model)) {
                _.forEach(model, function (attachment) {
                    _.forEach(service.IMG_EXTENSIONS, function (ext) {
                        if (endsWith(attachment.datas_fname, ext)) {
                            images.push(attachment);
                        }
                    });
                });
                return images;
            } else {
                return service.getAttachments(model).then(function (attachments) {
                    _.forEach(attachments.attachments, function (attachment) {
                        _.forEach(service.IMG_EXTENSIONS, function (ext) {
                            if (endsWith(attachment.datas_fname, ext)) {
                                images.push(attachment);
                            }
                        });
                    });
                    return images;
                });
            }
        };

        var endsWith = function(str, suffix) {
            var lower = str.toLowerCase();
            return lower.indexOf(suffix, str.length - suffix.length) !== -1;
        };

        var addOrigin = function(attachments, origin) {
            attachments.forEach(function(attachment){
                attachment.origin = settingsService.getContentType(origin).title;
            });
        };

        var addFolderData = function(attachments, res) {
            attachments.forEach(function(attachment){
                if (res.ask_id && res.ask_id[0]){
                    attachment.ask_id = res.ask_id;
                }
                if (res.project_id && res.project_id[0]){
                    attachment.project_id = res.project_id;
                }
                if (res._type){
                    attachment._type = res._type;
                }
            });
        };

        var addSwifId = function(attachments, id) {
            attachments.forEach(function(attachment){
                attachment.swif_id = id;
            });
        };

        return service;
    }

})();
